import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { IndexedStorageService } from './indexed-storage.service';

@Injectable()
export class IndexedTranslateLoader implements TranslateLoader {
  constructor(private indexedStorageService: IndexedStorageService) {}

  getTranslation(lang: string): Observable<any> {
    return this.indexedStorageService.getLocaleData(lang);
  }
}
